/* jshint esversion: 6 */

function init() {

  const selectChangeLocation = document.querySelectorAll('.js-select-change-window-location');

  selectChangeLocation.forEach(function(element) {
    element.addEventListener('change', function (event) {
      // console.dir(this.options[this.selectedIndex]);
      // window.location = this.options[this.selectedIndex].dataset.permalink;
      window.location = this.value;
    });

    element.addEventListener('keyup', function (event) {
      window.location = this.value;
    });
  });
}

export { init as default };
